import { render } from "./IngredientSearch.vue?vue&type=template&id=5574dfac&scoped=true"
import script from "./IngredientSearch.vue?vue&type=script&lang=js"
export * from "./IngredientSearch.vue?vue&type=script&lang=js"

import "./IngredientSearch.vue?vue&type=style&index=0&id=5574dfac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5574dfac"]])

export default __exports__